import request from "root/js/request";

export const getSharesProductsHistory = async ({ cabinet_id, shares_id }) => {
  const response = await request({
    url: `analytics/shares_log/?cabinet_id=${cabinet_id}&shares_id=${shares_id}`,
    method: "get",
  });
  return response;
};
